import { Table } from "antd";

const Table2 = () => {
    const dataSource = [
        // Virtual Account
        {
            key: '1-1',
            stt: '1',
            service: 'Dịch vụ Virtual Account',
            fee: '3.300 – 5.500 VNĐ',
            note: 'MC thông thường',
        },
        {
            key: '1-2',
            stt: '1',
            service: 'Dịch vụ Virtual Account',
            fee: 'Tối thiểu 6.600 VNĐ',
            note: 'MC có khả năng phát sinh tra soát, khiếu nại',
        },
        {
            key: '1-3',
            stt: '1',
            service: 'Dịch vụ Virtual Account',
            fee: 'Chiết khấu theo tỉ lệ %',
            note: (
                <>
                    MC có khả năng phát sinh tỉ lệ tra soát, khiếu nại cao.
                    <br />
                    Tỉ lệ điều chỉnh tùy từng trường hợp MC cụ thể
                </>
            ),
        },

        // Firm Banking
        {
            key: '2-1',
            stt: '2',
            service: 'Dịch vụ Firm Banking',
            fee: '3.300 – 5.500 VNĐ',
            note: 'MC thông thường',
        },
        {
            key: '2-2',
            stt: '2',
            service: 'Dịch vụ Firm Banking',
            fee: 'Tối thiểu 6.600 VNĐ',
            note: 'MC có khả năng phát sinh tra soát, khiếu nại',
        },
        {
            key: '2-3',
            stt: '2',
            service: 'Dịch vụ Firm Banking',
            fee: 'Chiết khấu theo tỉ lệ %',
            note: (
                <>
                    MC có khả năng phát sinh tỉ lệ tra soát, khiếu nại cao.
                    <br />
                    Tỉ lệ điều chỉnh tùy từng trường hợp MC cụ thể
                </>
            ),
        },

        // Row 3
        {
            key: '3',
            stt: '3',
            service: 'Phí dịch vụ hỗ trợ xác thực thông tin tài khoản/thẻ ngân hàng',
            fee: '2.200 VNĐ',
            note: '',
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 65,
            align: 'center',

            onCell: (record) => {
                if (record.key === '1-1' || record.key === '2-1') {
                    return {
                        rowSpan: 3,
                    };
                }

                if (
                    record.key === '1-2' ||
                    record.key === '1-3' ||
                    record.key === '2-2' ||
                    record.key === '2-3'
                ) {
                    return {
                        rowSpan: 0,
                    };
                }

                return {};
            },
        },

        {
            title: 'Dịch vụ',
            dataIndex: 'service',
            key: 'service',
            width: 360,

            onCell: (record) => {
                if (record.key === '1-1' || record.key === '2-1') {
                    return {
                        rowSpan: 3,
                    };
                }

                if (
                    record.key === '1-2' ||
                    record.key === '1-3' ||
                    record.key === '2-2' ||
                    record.key === '2-3'
                ) {
                    return {
                        rowSpan: 0,
                    };
                }

                return {};
            },
        },

        {
            title: 'Mức phí/Giao dịch (đã gồm VAT)',
            dataIndex: 'fee',
            key: 'fee',
            width: 330,
            align: 'center',
        },

        {
            title: 'Ghi chú',
            dataIndex: 'note',
            key: 'note',
            width: 500,
        },
    ];
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-4 mb-3 text-center">BẢNG 2: PHÍ KINH DOANH ĐỀ XUẤT CHO CÁC DỊCH VỤ HỖ TRỢ THU HỘ/ HỖ TRỢ CHI HỘ</h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
                <div className="mt-3">
                    <div className="fw-bold fst-italic">
                        Lưu ý:
                    </div>

                    <div className="ps-4">
                        <div>
                            - MC chỉ qua kênh BIDV,
                            áp dụng Biểu phí theo giá trị chi
                        </div>

                        <div>
                            - MC chỉ qua kênh WRB,
                            áp dụng Biểu phí mặc định, không quy định giá trị chi
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};
export default Table2;